<template>
  <div v-if="offices === null" class="flex w-full justify-center p-6">
    <loader />
  </div>
  <div v-else class="bg-white flex flex-col w-full">
    <div class="bg-grey-lighter border" v-if="mode === 'edit'">
      <button class="px-2 py-3 bg-grey-lighter hover:bg-grey-light relative group" title="Office">
        <i class="fas fa-building fa-fw"></i>
        <i class="fas fa-caret-down"></i>
        <div class="bg-white absolute pin-l pin-t-full border rounded-b whitespace-no-wrap shadow hidden group-hover:block z-10 overflow-y-auto max-h-64">
          <div class="flex flex-col">
            <button class="border-b px-3 py-2 hover:bg-grey-lighter text-left" @click="localOfficeId = null">
              <i class="fas fa-check mr-2" :class="{ invisible: localOfficeId !== null }"></i> All Offices
            </button>
            <button v-for="office in offices.data" :key="office.id" class="border-b px-3 py-2 hover:bg-grey-lighter text-left" @click="localOfficeId = office.id">
              <i class="fas fa-check mr-2" :class="{ invisible: localOfficeId !== office.id }"></i> {{ office.address_town }}
            </button>
          </div>
        </div>
      </button>
      <button class="px-2 py-3 bg-grey-lighter hover:bg-grey-light border-l" title="Interactive" @click="content.interactive = !content.interactive">
        <i class="fas fa-mouse-pointer fa-fw"></i> <i class="fas" :class="content.interactive ? 'fa-check-circle text-green-dark' : 'fa-times-circle text-red-dark'"></i>
      </button>
    </div>
    <GmapMap
      ref="map"
      :center="center"
      :zoom="zoom"
      :options="{disableDefaultUI: true, draggable: content.interactive, scrollWheel: false, zoomControl: content.interactive, maxZoom: 15}"
      map-type-id="roadmap"
      class="w-full h-64"
      @idle="initMap"
    >
      <GmapMarker
        v-for="office in selectedOffices"
        :key="office.id"
        :position="{lat: office.coordinates.lat, lng: office.coordinates.lon }"
        :title="`${office.address_town} Office`"
      />
    </GmapMap>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'
import { filter } from 'lodash'
import { gmapApi } from 'vue2-google-maps'

export default {
  props: {
    value: Object,
    mode: String,
    officeId: [Number, null]
  },
  data () {
    return {
      offices: null,
      center: { lat: 0, lng: 0 },
      zoom: 15,
      loaded: false
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    localOfficeId: {
      get () {
        return this.officeId
      },
      set (value) {
        this.$emit('office-change', value)
      }
    },
    selectedOffices () {
      return this.offices ? (this.localOfficeId ? filter(this.offices.data, (office) => office.id === this.localOfficeId) : this.offices.data) : []
    },
    google: gmapApi
  },
  created () {
    this.getOffices()
  },
  methods: {
    initMap () {
      if (this.loaded) {
        return
      }
      this.loaded = true
      this.fitBounds()
    },
    getOffices () {
      v2Api.get('office', {
        params: {
          client_id: this.selectedOffice.client_id,
          limit: 50
        }
      }).then((response) => {
        this.offices = response.data
      })
    },
    fitBounds () {
      if (this.selectedOffices.length === 0 || !this.$refs.map) {
        return
      }

      let bounds = new this.google.maps.LatLngBounds()

      for (let i = 0; i < this.selectedOffices.length; i++) {
        bounds.extend({ lat: this.selectedOffices[i].coordinates.lat, lng: this.selectedOffices[i].coordinates.lon })
      }

      this.$refs.map.fitBounds(bounds)
    }
  },
  watch: {
    selectedOffices () {
      this.fitBounds()
    },
    mode () {
      this.fitBounds()
    },
    'content.interactive' () {
      this.fitBounds()
    }
  }
}
</script>
